import React from "react";
import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppTooltip from "@/components/AppTooltip";
import AppIcon from "@/components/AppIcon";

interface InfoSectionProps {
  label: string; // Left column content
  labelTootltip?: string | null; // Left column content
  content: React.ReactNode; // Right column content
  className?: string; // Optional additional classes
}

const AppInfoSection: React.FC<InfoSectionProps> = ({ label, labelTootltip = null, content, className }) => {
  return (
    <AppBox
      className={`flex-col gap-2 sm:flex-row px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0 ${className || ""}`}
    >
      {/* Label Column */}
      <dt className="text-sm font-medium text-gray-900">
        <AppBox align="center" gap={1}>
          <AppText variant="label">{label}</AppText>
          {
            labelTootltip &&
              <AppTooltip title={labelTootltip}>
                <AppIcon name="help" size={14} />
              </AppTooltip>
          }
        </AppBox>
      </dt>

      {/* Content Column */}
      <dd className="sm:col-span-2 flex sm:mt-0 w-full md:w-auto md:text-left">{content}</dd>
    </AppBox>
  );
};

export default AppInfoSection;